import { useSelector } from "react-redux";
import useBootstrap from "../customHooks/useBootstrap.js";
import BaseImage from "../baseComponents/baseImage.js";


const Banner = ({}) => {

    const randomBanner = useSelector(state => state.systemState.settings.randomBanner);
  
    const { trashold, classes } = useBootstrap();
  
    if ((randomBanner ?? '') === '')
    {
      return <></>
    }
  
    return (
      <>
        <div
          className={`w-75 ${classes.onOrAboveTrashold.show(true)}`}
        >
          <a href={randomBanner.link}>
            <BaseImage style={{ width: "100%" }} src={randomBanner.img} />
          </a>
        </div>
  
        <div
         className={`w-100 ${classes.onOrAboveTrashold.show(false)}`}
        >
          <a href={randomBanner.link}>
            <BaseImage style={{ width: "100%" }} src={randomBanner.img} />
          </a>
        </div>
  
      </>
    );
  };



  export default Banner;